export enum ShipmentStopType {
  DROP_OFF = 'DROP_OFF',
  PICKUP = 'PICKUP',
  DROP_OFF_PICKUP = 'DROP_OFF_PICKUP',
  TERMINAL = 'TERMINAL',
  UNKNOWN = 'UNKNOWN',
}

export const SHIPMENT_STOP_PICKUP_TYPES = [
  ShipmentStopType.PICKUP,
  ShipmentStopType.DROP_OFF_PICKUP,
];

export const SHIPMENT_STOP_DROP_OFF_TYPES = [
  ShipmentStopType.DROP_OFF,
  ShipmentStopType.DROP_OFF_PICKUP,
];
